export default __webpack_public_path__ + "static/media/follow_the_line.ee223438.png";